<template>
  <!-- <div class="page-intro">
    <div class="back-link">
      &nbsp;<span class="f-ticker">← </span>
      <RouterLink to="/writing" class="f-ticker">Read more posts</RouterLink>
    </div>
  </div> -->
  <section class="page-intro">
    <div class="tag-list">
      <div class="tag">&nbsp;<span class="f-ticker">← </span></div>
      <RouterLink to="/writing" class="f-ticker">back</RouterLink>
    </div>
    <div class="tag-list">
      <span class="tag icon-text">to more posts</span>
    </div>
  </section>
</template>
<style lang="scss" scoped>
a {
  text-decoration: none;
  color: white;
  position: relative;
  transition: all 0.3s ease;
  &:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background: white;
    transition: all 0.3s ease;
    z-index: -1;
  }

  &:hover {
    color: black;
    &:after {
      height: 100%;
    }
  }
}
</style>
